import { CSmartTable } from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  capitalizeWords,
  changeGMTFormate,
  StatusConversion,
} from "../../Components/allFunctions";

import Constants from "../../Constants";
import { authFetch } from "../../utils/authFetch";

const ADMIN_ENDPOINT = Constants.AUTH_BASE_URL + "/api/v1/admin";

const FulFilledOrder = (props) => {
  const lang = props.Language;
  const params = useParams();

  const [fullfillesData, setFullfilledData] = useState([]);

  const [loading, setLoading] = useState(true);

  const [accessToken, setAccessToken] = useState("");

  const [OrderStatus, setOrderStatus] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [totalOrders, setTotalOrders] = useState(0);

  const navigate = useNavigate();
  const isVendor = localStorage.getItem("is_vendor") === "true";

  useEffect(() => {
    if (isVendor && params?.status === "cancelled") {
      navigate("/orders");
    }
  }, [isVendor, params?.status, navigate]);

  const changeHandler = (e) => {
    setOrderStatus(e.target.value);
    navigate(e.target.value);
  };
  const customItemsPerPageLabel =
    lang === "en" ? "Items per Page:" : "项目/页 : ";
  const customTableFilterLabel = lang === "en" ? "Filter" : "筛选";

  const columns = [
    {
      key: "id",
      label: "ID",
      filter: false,
      sorter: false,
    },
    {
      key: "OrderName",
      label: lang === "en" ? "Order" : "订单",
    },
    {
      key: "CreatedAt",
      label: lang === "en" ? "Date" : "日期",
    },
    {
      key: "CustomerName",
      label: lang === "en" ? "Customer" : "客户",
    },
    {
      key: "FulfillmentStatus",
      label: lang === "en" ? "Fulfillment Status" : "进度状态",
    },
    {
      key: "Items",
      label: lang === "en" ? "Items" : "项目",
    },
    // {
    //   key: "TeamName",
    //   label: lang === "en" ? "Team" : "团队",
    // },
    // {
    //   key: "EnterpriseName",
    //   label: lang === "en" ? "Enterprise" : "企业",
    // },
    {
      key: "Tag",
      label: lang === "en" ? "Order Tags" : "供应商",
    },
    {
      key: "additionalInfo",
      label: lang === "en" ? "User Data" : "附加資訊",
      sorter: true,
    },
    {
      key: "messageCount",
      label: lang === "en" ? "Message Count" : "消息数",
    },
  ];

  const getFullfilledOrders = (page = currentPage, itemsPerPage = perPage) => {
    try {
      setLoading(true);

      let queryParam;
      if (params?.status === "message") {
        queryParam = "has_messages=true";
      } else if (["awaiting_review", "reviewed", "manufactured", "shipped", "cancelled"].includes(params?.status)) {
        queryParam = `production_status=${params?.status}`;
      } else {
        queryParam = `fulfillment_status=${params?.status}`;
      }

      authFetch(
        `${ADMIN_ENDPOINT}/orders?${queryParam}&page=${page}&per_page=${itemsPerPage}`,
        {}
      )
        .then((response) => response.json())
        .then((data) => {
          const meta = data.meta || {};
          setCurrentPage(meta.page || 1);
          setTotalPages(meta.total_pages || 1);
          setTotalOrders(meta.total || 0);
          setPerPage(meta.per_page || itemsPerPage);

          const processedOrders = (data.orders || []).map((order) => {
            const additionalInfo = order.user_data_status || "";
            let className = "";
            if (additionalInfo === "Uploaded") {
              className = "scan-status scan-status-uploaded";
            } else if (additionalInfo) {
              className = "error-tag-highlight";
            }

            return {
              OrderId: order.slug,
              OrderName: order.shopify_order_name || order.slug,
              CreatedAt: order.created_at,
              CustomerName: order.customer_name || "",
              FulfillmentStatus: order.production_status || "unknown",
              Items: String(order.items || 0),
              Tag: order.tag || "",
              messageCount: order.message_count || 0,
              additionalInfo,
              additionalInfoClass: className,
            };
          });

          setFullfilledData(processedOrders);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    getFullfilledOrders(1, perPage);
  }, [params?.status]);

  return (
    <div className="container-fluid">
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800 HeadTitles">
          {lang === "en" ? "Orders" : "订单"}
        </h1>
      </div>

      {/* <div className="row">
        <div className="col-xl-12 col-md-12 mb-12">
          <h3 className="SubHeadTitles">{StatusConversion(params?.status, lang)}</h3>
          <div className="card shadow mb-4 flaged">
            <div className="card-body orders-table">
              <div className="tableDropDown">
              <div className="DropdownTittle">{lang==="en" ? "Order Status":"订单状态"}</div>
                <select
                  className="custom-select"
                  value={OrderStatus}
                  onChange={changeHandler}
                >
                  <option value="" disabled>
                  {lang==="en" ? "Order Status":"订单状态"}
                  </option>
                  <option value="/orders">{lang==="en" ? "All Orders":"所有订单"}</option>
                  <option value="/orders/awaiting_review">{lang==="en" ? "Awaiting Review":"等待审核"}</option>
                  <option value="/orders/reviewed">{lang==="en" ? "Reviewed":"已审核"}</option>
                  <option value="/orders/manufactured">{lang==="en" ? "Manufactured":"已生产"}</option>
                  <option value="/orders/quality-assured">{lang==="en" ? "Quality Assured":"质量已把关"}</option>
                  <option value="/orders/packaging">{lang==="en" ? "Packaging":"包装"}</option>
                  <option value="/orders/shipped">{lang==="en" ? "Shipped":"已发货"}</option>
                  <option value="/orders/fulfilled">{lang==="en" ? "Fulfilled":"實現了"}</option>
                </select>
              </div>
              <CSmartTable
                responsive="true"
                items={fullfillesData}
                columns={columns}
                columnSorter
                tableFilter
                tableFilterPlaceholder={lang==="en" ? "Search...":"搜索..."}
                pagination
                loading={loading}
                itemsPerPage={20}
                itemsPerPageSelect
                itemsPerPageLabel={customItemsPerPageLabel}
                tableProps={{
                  hover: true,
                  responsive: true,
                  striped: true,
                  className: "flagged-table",
                }}
                scopedColumns={{
                  
                  ID: (item, i) => {
                    const flaggedClassName =
                     
                      item.Flag === 1 ? "" : "";
                    return <td className={flaggedClassName}>{i + 1}</td>;
                  },
                  OrderName: (items) => {
                    const flaggedClassName =
                     
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        <Link
                          to={`/order/${items.OrderId}`}
                          className={flaggedClassName}
                        >
                          {items.OrderName}
                        </Link>
                      </td>
                    );
                  },
                  Flag: (items) => {
                    const flaggedClassName =
                      // items.Flag === 1 ? "flagged-row" : "";
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        {items.Flag === 1 ? "Flag" : ""}
                      </td>
                    );sortedOrders
                    const flaggedClassName =
                    
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        {items.FlagBy == "null" || items.Flag === 0
                          ? ""
                          : capitalizeWords(items.FlagBy)}
                      </td>
                    );
                  },
                  FulfillmentStatus: (items) => {
                    const flaggedClassName =
                    
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                       
                        {StatusConversion(items.FulfillmentStatus, lang)}
                      </td>
                    );
                  },
                  CustomerName: (items) => {
                    const flaggedClassName =
                      
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        {capitalizeWords(items.CustomerName)}
                      </td>
                    );
                  },
                  CreatedAt: (items) => {
                    const flaggedClassName =
                      
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>{items.CreatedAt}</td>
                    );
                  },

                  Items: (items) => {
                    const flaggedClassName =
                   
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        {capitalizeWords(items.Items)}
                      </td>
                    );
                  },
                  Tag: (items) => {
                    const flaggedClassName =
              
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        {capitalizeWords(items.Tag)}
                      </td>
                    );
                  },
                  MessageCount: (items) => {
                    const flaggedClassName =
                  
                      items.Flag === 1 ? "" : "";
                    return (
                      <td className={flaggedClassName}>
                        <div className="OrderMessageCount">{(items.messageCount)}</div>
                        
                      </td>
                    );
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div> */}

      <div className="row">
        <div className="col-xl-12 col-md-12 mb-12">
          <h3 className="SubHeadTitles">
            {StatusConversion(params?.status, lang)}
          </h3>

          <div className="card shadow mb-4 flaged">
            <div className="card-body orders-table">
              <div className="tableDropDown">
                <div className="DropdownTittle">
                  {lang === "en" ? "Order Status" : "订单状态"}
                </div>
                <select
                  className="custom-select"
                  value={OrderStatus}
                  onChange={changeHandler}
                >
                  <option value="/orders">
                    {lang === "en" ? "All Orders" : "所有订单"}
                  </option>
                  <option value="/orders/awaiting_review">
                    {lang === "en" ? "Awaiting Review" : "等待审核"}
                  </option>
                  <option value="/orders/reviewed">
                    {lang === "en" ? "Reviewed" : "已审核"}
                  </option>
                  <option value="/orders/manufactured">
                    {lang === "en" ? "Manufactured" : "已生产"}
                  </option>
                  {/* <option value="/orders/quality-assured">
                      {lang === "en" ? "Quality Assured" : "质量已把关"}
                    </option>
                    <option value="/orders/packaging">
                      {lang === "en" ? "Packaging" : "包装"}
                    </option> */}
                  <option value="/orders/shipped">
                    {lang === "en" ? "Shipped" : "已发货"}
                  </option>
                  {/* <option value="/orders/fulfilled">
                    {lang === "en" ? "Fulfilled" : "實現了"}
                  </option> */}
                  {localStorage?.getItem("super_admin") === "true" && localStorage?.getItem("is_vendor") !== "true" && (
                    <option value="/orders/cancelled">
                      {lang === "en" ? "Cancelled" : "取消"}
                    </option>
                  )}
                  <option value="/orders/message">
                    {lang === "en" ? "With Messages" : "有留言"}
                  </option>
                </select>
              </div>

              <div className="custom-table">
                <CSmartTable
                  responsive="true"
                  items={fullfillesData}
                  columns={columns}
                  columnSorter
                  tableFilter
                  tableFilterPlaceholder={
                    lang === "en" ? "Search..." : "搜索..."
                  }
                  tableFilterLabel={customTableFilterLabel}
                  loading={loading}
                  itemsPerPage={perPage}
                  tableProps={{
                    hover: true,
                    responsive: true,
                    striped: true,
                    className: "flagged-table",
                  }}
                  scopedColumns={{
                    id: (item, i) => {
                      return <td>{(currentPage - 1) * perPage + i + 1}.</td>;
                    },
                    OrderName: (items) => {
                      return (
                        <td>
                          <Link to={`/order/${items.OrderId}`}>
                            {items.OrderName}
                          </Link>
                        </td>
                      );
                    },
                    FulfillmentStatus: (items) => {
                      return (
                        <td>
                          {StatusConversion(items.FulfillmentStatus, lang)}
                        </td>
                      );
                    },
                    CustomerName: (items) => {
                      return (
                        <td>
                          {capitalizeWords(items.CustomerName)}
                        </td>
                      );
                    },
                    CreatedAt: (items) => {
                      return (
                        <td>
                          {changeGMTFormate(items.CreatedAt)}
                        </td>
                      );
                    },
                    Items: (items) => {
                      return (
                        <td>
                          {capitalizeWords(items.Items)}
                        </td>
                      );
                    },
                    Tag: (items) => {
                      return (
                        <td>
                          {items?.Tag?.split(",").map((tag, index) => {
                            const trimmedTag = tag?.trim();
                            let tagClass = "";

                            if (trimmedTag.toLowerCase() === "test") {
                              tagClass = "test-tag-highlight";
                            } else if (trimmedTag.toLowerCase() === "rmu") {
                              tagClass = "rmu-tag-success";
                            }

                            return (
                              <span key={index} className={tagClass}>
                                {capitalizeWords(trimmedTag)}
                                {index < items?.Tag?.split(",").length - 1 &&
                                  ", "}
                              </span>
                            );
                          })}
                        </td>
                      );
                    },
                    additionalInfo: (items) => (
                      <td>
                        <span className={items.additionalInfoClass}>
                          {items.additionalInfo}
                        </span>
                      </td>
                    ),
                    messageCount: (items) => {
                      return (
                        <td>
                          {items.messageCount != "0" ? (
                            <div className="OrderMessageCount">
                              {items.messageCount}
                            </div>
                          ) : lang === "en" ? (
                            "No Message"
                          ) : (
                            "沒有留言"
                          )}
                        </td>
                      );
                    },
                  }}
                />

                {/* Server-side pagination controls */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      <label className="me-2">{customItemsPerPageLabel}</label>
                      <select
                        className="form-select form-select-sm d-inline-block"
                        style={{ width: "auto" }}
                        value={perPage}
                        onChange={(e) => {
                          const newPerPage = Number(e.target.value);
                          setPerPage(newPerPage);
                          setCurrentPage(1);
                          getFullfilledOrders(1, newPerPage);
                        }}
                      >
                        {[10, 20, 50, 100].map((n) => (
                          <option key={n} value={n}>{n}</option>
                        ))}
                      </select>
                      <span className="ms-3 text-muted">
                        {lang === "en"
                          ? `Showing ${(currentPage - 1) * perPage + 1}–${Math.min(currentPage * perPage, totalOrders)} of ${totalOrders}`
                          : `显示 ${(currentPage - 1) * perPage + 1}–${Math.min(currentPage * perPage, totalOrders)} 共 ${totalOrders}`}
                      </span>
                    </div>
                    <nav>
                      <ul className="pagination mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => { setCurrentPage(1); getFullfilledOrders(1, perPage); }}>«</button>
                        </li>
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => { const p = currentPage - 1; setCurrentPage(p); getFullfilledOrders(p, perPage); }}>‹</button>
                        </li>
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let page;
                          if (totalPages <= 5) {
                            page = i + 1;
                          } else if (currentPage <= 3) {
                            page = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            page = totalPages - 4 + i;
                          } else {
                            page = currentPage - 2 + i;
                          }
                          return (
                            <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                              <button className="page-link" onClick={() => { setCurrentPage(page); getFullfilledOrders(page, perPage); }}>{page}</button>
                            </li>
                          );
                        })}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => { const p = currentPage + 1; setCurrentPage(p); getFullfilledOrders(p, perPage); }}>›</button>
                        </li>
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => { setCurrentPage(totalPages); getFullfilledOrders(totalPages, perPage); }}>»</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FulFilledOrder;
